import React, { useState, useEffect, useRef } from 'react'
import { Box } from 'reflexbox'
import PropTypes from 'prop-types'

import { useHotkey, useOuterClickNotifier } from 'hooks/outerClick'
import { Input, Label, Results, Option } from './styles'

const SearchInput = ({ label, options, value, selectedValue, ...props }) => {
  const ResultsRef = useRef(null)
  const [showResults, setShowResults] = useState(true)

  useEffect(() => {
    setShowResults(true)
  }, [value])

  useHotkey('Escape', () => setShowResults(false))

  useOuterClickNotifier(() => setShowResults(false), ResultsRef)

  return (
    <Box sx={{ position: 'relative' }} {...props}>
      <Input type='text' autoComplete='off' value={value} {...props} />
      {label && <Label>{label}</Label>}

      {value && (
        <Results show={showResults} ref={ResultsRef}>
          {options ? (
            options.map(result => (
              <Option
                onClick={() => {
                  selectedValue(result)
                  setShowResults(false)
                }}
              >
                {result}
              </Option>
            ))
          ) : (
            <Option>Nenhum resultado encontado.</Option>
          )}
        </Results>
      )}
    </Box>
  )
}

SearchInput.propType = {
  options: PropTypes.array.isRequired,
  selectedValue: PropTypes.func.isRequired,
}

export default SearchInput
